import { render, staticRenderFns } from "./individual-omr-result.html?vue&type=template&id=75aa7c95&scoped=true&"
import script from "./individual-omr-result.vue?vue&type=script&lang=js&"
export * from "./individual-omr-result.vue?vue&type=script&lang=js&"
import style0 from "./individual-omr-result.css?vue&type=style&index=0&id=75aa7c95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa7c95",
  null
  
)

export default component.exports